import i18n from '../utils/i18n';

type ErrorWithTitleAndDetails = {
	title: string;
	details: string;
	fields?: {
		validationErrors?: Record<string, string[]>;
	};
};

type ErrorWithMessage = {
	message: string;
};

type ErrorWithErrorsArray = {
	errors: unknown[];
};

export const parseErrorToString = (error: unknown): string => {
	// Handle array of errors
	if (
		typeof error === 'object' &&
		error !== null &&
		'errors' in error &&
		Array.isArray((error as ErrorWithErrorsArray).errors)
	) {
		const firstError = (error as ErrorWithErrorsArray).errors[0];
		return parseErrorToString(firstError);
	}

	// Handle error with title/details and possibly validationErrors
	if (
		typeof error === 'object' &&
		error !== null &&
		'title' in error &&
		'details' in error
	) {
		const { title, details, fields } = error as ErrorWithTitleAndDetails;

		// Handle validation errors if present
		if (
			fields?.validationErrors &&
			typeof fields.validationErrors === 'object'
		) {
			const messages: string[] = [];

			for (const field in fields.validationErrors) {
				const errors = fields.validationErrors[field];
				if (Array.isArray(errors)) {
					messages.push(...errors);
				}
			}

			if (messages.length > 0) {
				return messages.join('\n');
			}
		}

		// Fallback to details/title
		return details !== '' ? details : title;
	}

	// Handle plain string error
	if (typeof error === 'string') {
		return error;
	}

	// Handle error with a message property
	if (
		typeof error === 'object' &&
		error !== null &&
		'message' in error &&
		typeof (error as ErrorWithMessage).message === 'string'
	) {
		return (error as ErrorWithMessage).message;
	}

	// Fallback
	return i18n.t('general.something_went_wrong');
};
